export default "__VITE_ASSET__CDQGWxFZ__"